import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {
  Button,
  Row,
} from 'reactstrap'
import get from 'lodash/get'
import { FONTS } from '../../../../constants'

export const CategoryButton = (props) => {
  const { timesheets } = props
  const numberOfTimesheet = get(timesheets, 'timesheetApprovalsMeta.numberOfTimesheet', 0)
  const timesheetApproved = get(timesheets, 'timesheetApprovalsMeta.timesheetApproved', 0)
  const timesheetPending = get(timesheets, 'timesheetApprovalsMeta.timesheetPending', 0)
  const timesheetRejected = get(timesheets, 'timesheetApprovalsMeta.timesheetRejected', 0)
  // const timesheetUnsubmited = get(timesheets, 'timesheetApprovalsMeta.timesheetUnsubmited', 0)

  return (
    <Wrapper>
      <Categorybutton
        onClick={ () => get(props, 'clickFilterButton')(1) }
        active={ get(props, 'filterButton') === 1 }
      >
        <TextRow>
          <Circle />
          <TextButton color=''>Show All</TextButton>
        </TextRow>
        <TextRow>
          <TextNumber >{ `${numberOfTimesheet} People` }</TextNumber>
        </TextRow>
      </Categorybutton>
      <Categorybutton
        onClick={ () => get(props, 'clickFilterButton')(3) }
        active={ get(props, 'filterButton') === 3 }
      >
        <TextRow>
          <Circle
            color='#F0AD4E'
            active={ get(props, 'filterButton') === 3 }
          />
          <TextButton
            color='#F0AD4E'
            active={ get(props, 'filterButton') === 3 }
          >
          Pending
          </TextButton>
        </TextRow>
        <TextRow>
          <TextNumber>{ `${timesheetPending} People` }</TextNumber>
        </TextRow>
      </Categorybutton>
      <Categorybutton
        onClick={ () => get(props, 'clickFilterButton')(4) }
        active={ get(props, 'filterButton') === 4 }
      >
        <TextRow>
          <Circle
            color='#5CB85C'
            active={ get(props, 'filterButton') === 4 }
          />
          <TextButton
            color='#5CB85C'
            active={ get(props, 'filterButton') === 4 }
          >Approve</TextButton>
        </TextRow>
        <TextRow>
          <TextNumber>{ `${timesheetApproved} People` }</TextNumber>
        </TextRow>
      </Categorybutton>
      <Categorybutton
        onClick={ () => get(props, 'clickFilterButton')(5) }
        active={ get(props, 'filterButton') === 5 }
      >
        <TextRow>
          <Circle
            color='#D44B49'
            active={ get(props, 'filterButton') === 5 }
          />
          <TextButton
            color='#D44B49'
            active={ get(props, 'filterButton') === 5 }
          >
          Rejected
          </TextButton>
        </TextRow>
        <TextRow>
          <TextNumber>{ `${timesheetRejected} People` }</TextNumber>
        </TextRow>
      </Categorybutton>
    </Wrapper>
  )
}

CategoryButton.propTypes = {
  timesheets: PropTypes.object,
}
CategoryButton.defaultProps = {
  timesheets: {},
}

const Categorybutton = styled(Button)`
  background-color: ${(props) => {
    if (props.active) {
      return '#D44B49 !important'
    } return '#ffffff'
  }};
  color: #000;
  height: 50px;
  width: 10%;
  margin: 5px;
  border: ${(props) => {
    if (props.active) {
      return '1px solid #D44B49 !important'
    } return '#cccccc'
  }};
  cursor: pointer;
`
const TextRow = styled(Row)`
  justify-content: center;
`
const TextButton = styled.label`
  font-family: ${FONTS.GOTHAM} !important;
  text-align: center;
  margin-bottom: 0;
  color: ${(props) => {
    if (props.active) {
      return '#ffffff !important'
    } return props.color
  }};
  font-size: ${FONTS.SMALL_SIZE};
  cursor: pointer;
`
const TextNumber = styled.label`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  text-align: center;
  margin-bottom: 0;
  width: 100%;
  font-size: ${FONTS.SMALL_SIZE};
  cursor: pointer;
`
const Wrapper = styled.div`
  background-color: #EEEEEE ;
  height: 60px;
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: center;
  border-top: 1px solid #CCCCCC;
  border-bottom: 1px solid #EEEEEE;
  padding-left: 10px;
`
const Circle = styled.div`
  height: 8px;
  width: 8px;
  background-color: ${(props) => {
    if (props.active) {
      return '#ffffff !important'
    } return props.color
  }};
  border-radius: 50%;
  margin-right: 5px;
  margin-bottom: auto ;
  margin-top: auto;
`



// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/timesheet-approval/category-button.js